import { Component, Event, EventEmitter, FunctionalComponent, h, Host, Prop } from '@stencil/core'
import { JSXBase } from '@stencil/core/internal'
import { sortBy } from 'lodash-es'
import { ICallActionItemAssignee } from 'src/page/call/detail/types'

const AssignmentMenuItem: FunctionalComponent<JSXBase.IntrinsicElements['button']> = (
  { class: className = '', ...attrs },
  children
) => (
  <button
    class={`
      flex items-start py-1 pr-3 pl-2 w-full hover:text-brand-base hover:bg-surface-upper transition duration-200 cursor-pointer select-none spacing-x-2
      ${className}
    `}
    {...attrs}
  >
    <span class='text-base font-extrabold leading-none text-left'>{children}</span>
  </button>
)

@Component({
  tag: 'action-item-assignment-menu',
})
export class ActionItemAssignmentMenu {
  @Event() assign: EventEmitter<ICallActionItemAssignee>

  @Prop() assigneeName: string
  @Prop() candidateAssignees: ICallActionItemAssignee[] = []

  render() {
    return (
      <Host style={{ minWidth: '180px' }}>
        <ui-scrollarea
          style={{ maxHeight: '150px' }}
          showBarX
          showBarY
          shadowStyleX={{ display: 'none' }}
          shadowStyleY={{ display: 'none' }}
        >
          {sortBy(this.candidateAssignees, ['name']).map((candidateAssignee) => {
            return (
              <AssignmentMenuItem
                onClick={() => {
                  this.assign.emit(candidateAssignee)
                }}
              >
                <span class='text-sm'>{candidateAssignee.name}</span>
              </AssignmentMenuItem>
            )
          })}
        </ui-scrollarea>
      </Host>
    )
  }
}
